import type { JSX } from "react";
import { CharterIndexLogo } from "@charterindex/armoury-www";
import { ButtonBase, Typography, css, styled, useMediaQuery, useTheme } from "@mui/material";
import { useObservable } from "ecce-react";
import { Trans } from "react-i18next";
import { useAuth, useSetting } from "../../../services/services-context";
import { MasqueradeIcon } from "../../atoms/icons/masquerade-icon";


const MasqueradeButton = styled(ButtonBase)(({ theme }) => css`
	background-color: ${theme.palette.warning.main};
	color: ${theme.palette.warning.contrastText};
	padding: ${theme.spacing(0, 1)};
	
	height: 100%;
	display: flex;
	align-items: center;
	
	svg {
		margin-inline-end: ${theme.spacing(1)};
	}
`);

const LogoBanner = styled("a")`
	&, * {
		height: 100%;
		display: flex;
		align-items: center;
		margin-inline-start: 4px;
		svg {
			height: 17px;
		}
	}
`;

export const NavBanner = (): JSX.Element => {
	const auth = useAuth();
	useObservable(auth, "masquerading");
	const small = useMediaQuery(useTheme().breakpoints.only("xs"));

	const agentUrl = useSetting("agentUrl");

	if(auth.masquerading) {
		return (
			<MasqueradeButton
				onClick={ auth.masqueradeController.openDialog }
			>
				<MasqueradeIcon/>
				&nbsp;
				<Typography>
					<Trans
						i18nKey="admin:masquerade.masqueradingAs"
						values={{ name: auth.activeUser.name }}
						components={{ strong: <strong/> }}
					/>
				</Typography>
			</MasqueradeButton>
		);
	}

	return (
		<LogoBanner href={ agentUrl }>
			<CharterIndexLogo color="white" iconOnly={ small }/>
		</LogoBanner>
	);
};
